export const CardConfig = {
  cards_settings: [
    {
      "product_type": "PERSONALIZED-CRD",
      "product_type_label": "Personalized tribute card",
      "getRecipients": true
    },
    {
      "product_type": "E-CRD",
      "product_type_label": "E-Card",
      "getRecipients": true
    },
    {
      "product_type": "BLANK-CRD",
      "product_type_label": "Write your own printed card",
      "getRecipients": false,
      "quantity": true
    },
    {
      "product_type": "NON-ANIMATED-BUSINESS-CRD",
      "product_type_label": "Personalized e-card for businesses",
      "getRecipients": false,
      "quantity": false,
      "fields": [
        {
          "type": "input-text",
          "name": "name",
          "label": "Your name and business as it will appear on card",
          "max_char": 80,
          "mandatory": true
        },
        {
          "type": "email",
          "name": "email",
          "label": "Your email (we'll send you the ecard to distribute)",
          "mandatory": true
        },
        {
          "type": "input-textarea",
          "name": "message",
          "label": "Short message on card",
          "max_char": 140,
          "mandatory": true
        },
        {
          "type": "text",
          "name": "note",
          "note": "NOTE: If you want to add logo, email holidaycards@glwd.org with your name and logo and someone will be in touch."
        }
      ]
    },
    {
      "product_type": "NON-ANIMATED-PERSONAL-CRD",
      "product_type_label": "Personalized e-card",
      "getRecipients": false,
      "quantity": false,
      "fields": [
        {
          "type": "input-text",
          "name": "name_personalization",
          "label": "Your name as it will appear on card",
          "max_char": 80,
          "mandatory": true
        },
         {
          "type": "email",
          "name": "email",
          "label": "Your email (we'll send you the ecard to distribute)",
          "mandatory": true
        },
        {
          "type": "input-text",
          "name": "message",
          "label": "Short message on card",
          "max_char": 140,
          "mandatory": false
        },
       
      ]
    },
    {
      "product_type": "ANIMATED-CRD",
      "product_type_label": "Animated Card",
      "getRecipients": false,
      "quantity": false,
      "fields": [
        {
          "type": "input-text",
          "name": "name_personalization",
          "label": "Your name and business as it will appear on card",
          "max_char": 80,
          "mandatory": true
        },
        {
          "type": "email",
          "name": "email",
          "label": "Your email (we'll send you the ecard to distribute)",
          "mandatory": true
        },
        {
          "type": "input-textarea",
          "name": "message",
          "label": "Short message on card",
          "max_char": 140,
          "mandatory": true
        },
        {
          "type": "text",
          "name": "note",
          "note": "NOTE: If you want to add logo, email holidaycards@glwd.org with your name and logo and someone will be in touch."
        }
      ]
    },
    {
      "product_type": "BOX-SET-CRD",
      "product_type_label": "Box Set Card",
      "getRecipients": false,
      "quantity": true
    },
    {
      "product_type": "CSTM-CRD-PRINT",
      "product_type_label": "Custom Print Card",
      "getRecipients": true,
      "quantity": false
    },
    {
      "product_type": "CSTM-CRD-EMAIL",
      "product_type_label": "Custom Email Card",
      "getRecipients": true,
      "quantity": false
    }
  ]

};
